import { useEffect } from 'react';

export const AudioAndVideoEnabledGuard = () => {
  useEffect(() => {
    navigator.mediaDevices
      .getUserMedia({ audio: true, video: true })
      .then((stream) => {
        stream.getTracks().forEach((track) => track.stop());
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return <></>;
};
